import { render } from "./monospace_block.vue?vue&type=template&id=0aaad692&ts=true"
import script from "./monospace_block.vue?vue&type=script&lang=ts"
export * from "./monospace_block.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/monospace_block.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aaad692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aaad692', __exports__)) {
    api.reload('0aaad692', __exports__)
  }
  
  module.hot.accept("./monospace_block.vue?vue&type=template&id=0aaad692&ts=true", () => {
    api.rerender('0aaad692', render)
  })

}


export default __exports__